// Misc
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';

// Atoms
import { LinearProgress } from 'material-ui/Progress';

// Styles
import styles from './styles';

const mapStateToProps = ({ appProgress }) => ({
  activatorsCount: appProgress.activators.length
});

@connect(mapStateToProps)
@withStyles(styles)
export default class AppProgressIndicator extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    activatorsCount: PropTypes.number.isRequired,
  };

  render() {
    const { classes, activatorsCount } = this.props;

    if (activatorsCount) {
      return (
        <div className={classes.root}>
          <LinearProgress color="accent" />
        </div>
      );
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/AppProgress/Indicator/index.js